import React, { useEffect, useRef, useState  } from 'react';
import { v4 as uuidv4 } from "uuid";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, DialogProps, IconButton, Paper, Box,  
  useMediaQuery,
  useTheme, 
  Slide} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ArrowBackIos, ArrowForwardIos, Close } from '@mui/icons-material';
import Draggable from 'react-draggable';
import useConfig from 'hooks/useConfig';
import { TransitionProps } from '@mui/material/transitions';

export interface CustomDialogButton {
    text: string;
    onClick: () => void;
    color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
    variant?: 'text' | 'outlined' | 'contained';
    align?: 'start' | 'end';
    disabled?:boolean;
}

function PaperComponent(paper_props:any) {
  
  const { dialog_id, ...rest } = paper_props;
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle={`#${dialog_id}-dialog-title`}
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...rest}  ref={nodeRef} />
    </Draggable>
  );
}



const SlideUpTransition = React.forwardRef((
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) => {
  console.log(1)
return <Slide direction="up" ref={ref} {...props} />});

const CustomDialog: React.FC<{
    role?: 'alert' | 'form';
    openDialog: boolean;
    onClose: () => void;
    children?: React.ReactElement;
    headerText?: string;
    messageText?: string;
    buttons?: CustomDialogButton[];
    closeButtonText?: string;
    showCloseButton?: boolean;
    showHeaderCloseButton?: boolean;
    isFormDialog?:boolean;
    isDraggble?:boolean;
    size?: DialogProps['maxWidth'];
    sx?: {};
}> = (props) => {
    const { role = 'alert', openDialog, onClose, children, buttons, headerText, messageText, showCloseButton,showHeaderCloseButton, closeButtonText,isDraggble,size,sx,isFormDialog = {} } = props;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    
    const { rtlLayout } = useConfig();
    const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>();
  const [dialog_id] = useState(() => `dlg-${uuidv4()}`);

  
//   useEffect(() => { 
//     if (!openDialog) return undefined; 
//     const timer = setTimeout(() => { 
//       if (!contentRef.current) return undefined; 
//       const container = contentRef.current; 
//       const mutationObserver = new MutationObserver(() => { 
//         const inner = container.querySelector('.form-main-cont') as HTMLElement | null; 
//         if (inner) { 
//           const resizeObserver = new ResizeObserver(() => { 
//             console.log('observer', inner.scrollHeight); 
//             const newHeight = inner.scrollHeight + 65; 
//             setHeight(prev => (prev !== newHeight ? newHeight : prev)); }); 
//             resizeObserver.observe(inner); 
//             mutationObserver.disconnect(); // stop after found 
//         } 
//       }); 
// mutationObserver.observe(container, { childList: true, subtree: true }); 
// return () => mutationObserver.disconnect(); 
// }, 0); 

// return () => clearTimeout(timer); 
// },[openDialog]);

const resizeObserverRef = useRef<ResizeObserver | null>(null);
const mutationObserverRef = useRef<MutationObserver | null>(null);

useEffect(() => {
  if (!openDialog) {
    // dialog is closing → clean observers so they don't see height 0
    if (resizeObserverRef.current) {
      resizeObserverRef.current.disconnect();
      resizeObserverRef.current = null;
    }
    if (mutationObserverRef.current) {
      mutationObserverRef.current.disconnect();
      mutationObserverRef.current = null;
    }
    return; // <-- no value
  }

  let cancelled = false;

  const timer = window.setTimeout(() => {
    if (cancelled) return;

    const container = contentRef.current;
    if (!container) {
      // if this still hits, we can bump timeout to e.g. 50ms
      return;
    }

    const attachResize = (inner: HTMLElement) => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }

      const ro = new ResizeObserver(() => {
        const h = inner.scrollHeight;
        if (!h) return; // ignore 0 (usually when closing / hidden)

        const newHeight = h + 65;
        setHeight(prev => (prev !== newHeight ? newHeight : prev));
      });

      ro.observe(inner);
      resizeObserverRef.current = ro;

      const initialH = inner.scrollHeight;
      if (initialH) {
        const initialHeight = initialH + 65;
        setHeight(prev => (prev !== initialHeight ? initialHeight : prev));
      }
    };

    const innerNow = container.querySelector('.form-main-cont') as HTMLElement | null;
    if (innerNow) {
      attachResize(innerNow);
      return;
    }

    const mo = new MutationObserver(() => {
      const inner = container.querySelector('.form-main-cont') as HTMLElement | null;
      if (!inner) return;

      attachResize(inner);

      if (mutationObserverRef.current) {
        mutationObserverRef.current.disconnect();
        mutationObserverRef.current = null;
      }
    });

    mo.observe(container, { childList: true, subtree: true });
    mutationObserverRef.current = mo;
  }, 0);

  // eslint-disable-next-line consistent-return
  return () => {
    cancelled = true;
    window.clearTimeout(timer);

    if (resizeObserverRef.current) {
      resizeObserverRef.current.disconnect();
      resizeObserverRef.current = null;
    }
    if (mutationObserverRef.current) {
      mutationObserverRef.current.disconnect();
      mutationObserverRef.current = null;
    }
  };
}, [openDialog]);



  // useEffect(() => {
  //   if (!openDialog) return undefined;
  
  //   const timer = setTimeout(() => {
  //     if (!contentRef.current) return undefined;
  
      
  //     const formMain = contentRef.current.querySelector('.form-main-cont') as HTMLElement | null;
  //   if (!formMain) return undefined;

  //     const observer = new ResizeObserver(() => {
  //       console.log('observer', formMain.scrollHeight);
  //       const newHeight = formMain.scrollHeight + 65;
  //       setHeight(prev => (prev !== newHeight ? newHeight : prev));
  //       //  setHeight(newHeight);
  //     });
  
  //     observer.observe(formMain);
  
  //     return () => observer.disconnect();
  //   }, 0);
  
  //   return () => clearTimeout(timer);
  // }, [openDialog]);

  // useEffect(() => {
  //   if (!openDialog || !contentRef.current) return undefined;
  
  //   const container = contentRef.current;
  
  //   const observer = new ResizeObserver(() => {
  //     const inner = container.querySelector('.form-main-cont') as HTMLElement | null;
      
  //     if (inner) {
  //       console.log('observer', inner.scrollHeight);
  //       const newHeight = inner.scrollHeight + 65;
  //       setHeight(newHeight);
  //     }
  //   });
  
  //   observer.observe(container);
  
  //   return () => observer.disconnect();
  // }, [openDialog]); // only runs when dialog opens/closes
  // useEffect(() => {
  //    if (!openDialog || !contentRef.current)  return undefined;

  //   const observed_child = contentRef.current.querySelector('.form-main-cont');
  //   if (!observed_child) return undefined;

  //   const observer = new ResizeObserver((entries) => {
  //     for (const entry of entries) {
  //       const { width: observedWidth, height: observedHeight } = entry.contentRect;
  //      // console.log(width, height);
  //       console.log(`Child resized: H:${observedHeight}`,observed_child.scrollHeight);
        
  //         const newHeight = observed_child.scrollHeight + 65; 
         
  //         setHeight(newHeight);
        
  //     }
  //   });

  //   observer.observe(observed_child);

  //   return () => {
  //     observer.disconnect();
  //   };
  

  // }, [openDialog, contentRef]);


  // useEffect(() => {
  //   if (openDialog) {
  //     const timer = setTimeout(() => {
  //       const contentEl = contentRef.current;
  //   if (contentEl) {
  //     const inner = contentEl.querySelector('.form-main-cont') as HTMLElement | null;
  //     if (inner) {
  //       const newHeight = inner.scrollHeight + 65; 
  //       console.log(inner.scrollHeight)
  //       setHeight(newHeight);
  //     }
  //   }
        
  //     }, 300); // delay to wait for content mount

  //     return () => clearTimeout(timer);
  //   }
  //   return undefined; // ✅ satisfies lint
  // }, [openDialog, children]);
  

    let dialog_styles ={};
    const dialog_mbl_styles ={};
    if(isFormDialog == true || role=='form'){
      dialog_styles = { 
        '& .MuiDialog-container': {
          height: '100%',
          '& .MuiPaper-root': {
            // height: '100%',
            // pb:0,
            // pt:0,
            // display: 'flex',
            // flexDirection: 'column',
            '& .MuiDialogContent-root': {
              pb:0,
            },
            '& .MuiDialogActions-root': {
              py:0,
            }
          }
        }
      };
     // if(isMobile){
        // dialog_mbl_styles = {
        //   '.MuiDialogContent-root': {
        //     px: 0,
        //     '.MuiBox-root': {
        //       borderRadius:0,
        //       borderLeft: 0,
        //       borderRight:0
        //     }
        //   }
        // };
     // }
    }
   
  const firstEndIndex = buttons?.findIndex(b => b.align !== 'start') ?? -1;

    return (
        <Dialog sx={{...dialog_styles,...dialog_mbl_styles,...sx}} 
        role={role}
        open={openDialog} 
        fullScreen={isMobile && role== 'form'}
        onClose={onClose} 
        aria-labelledby={`${dialog_id}-dialog-title`} 
        TransitionComponent={(isMobile && role == 'alert') ? SlideUpTransition : undefined}
        PaperProps={{
    sx: {
      ...(isMobile && role== 'alert' && {
        m: 0,
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        maxWidth: '100%',
        borderRadius: '16px 16px 0 0',
        maxHeight: '90vh'
      })
    }
  }}
        aria-describedby="alert-dialog-description" 
        PaperComponent={
          isDraggble
            ? (paper_props) => <PaperComponent {...paper_props} dialog_id={dialog_id} />
            : undefined
        }
        fullWidth={size != undefined} maxWidth={size || 'sm'}>
          
            {headerText && 
            <DialogTitle id={`${dialog_id}-dialog-title`}   style={{ cursor: isDraggble ? 'move': 'default' }}>
              {(isMobile && role == 'form') && <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            py: 0,
            pl:0,
            // position: 'absolute',
            // left: 12,
            // top: 12,
            color: theme.palette.grey[500],
          }}
        >
          {rtlLayout  ? <ArrowForwardIos /> : <ArrowBackIos />}
        </IconButton>}
              <FormattedMessage id={headerText} />
              </DialogTitle>}
           {!(isMobile && role == 'form') && showHeaderCloseButton && <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            color: theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>}
            <DialogContent sx={{pt:0,maxHeight:'100%', height: height ? `${height}px` : 'auto'}} ref={contentRef}>
           
            {messageText && (  <DialogContentText id="alert-dialog-description">
                    
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            {messageText}
                        </Typography>
                   
                </DialogContentText> )}
                {children}
               
            </DialogContent>
           {((buttons && buttons.length > 0) || showCloseButton) && 
           <DialogActions sx={{ px: 4, justifyContent: 'flex-start' }}>
  {buttons?.map((btn, index) => (
    <React.Fragment key={index}>
      {index === firstEndIndex && <Box sx={{ flex: 1 }} />}

      <Button
        variant={btn.variant || 'contained'}
        onClick={btn.onClick}
        color={btn.color}
        disabled={btn.disabled}
      >
        {btn.text && <FormattedMessage id={btn.text} />}
      </Button>
    </React.Fragment>
  ))}

  {showCloseButton && firstEndIndex === -1 && <Box sx={{ flex: 1 }} />}

  {showCloseButton && (
    <Button onClick={onClose} autoFocus>
      {closeButtonText || <FormattedMessage id="cancel" />}
    </Button>
  )}
</DialogActions>}
        </Dialog>
    );
};

export default CustomDialog;
